



























































import PageWithMainContainer from "@/components/PageWithMainContainer.vue";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import VirtualTable from "@/components/table/VirtualTable.vue";
import { onMounted } from "@vue/composition-api";
import Vue from "vue";
import { state } from "./data/state";
import DynamicsTableRow from "./DynamicsTableRow.vue";
export default Vue.extend({
  components: { PageWithMainContainer, SimpleNavTabs, VirtualTable },
  setup() {
    const {
      selected_tab,
      set_selected_tab,
      tabs,
      is_loading,
      table_config,
      items,
      load_more_items,
      has_no_results,
    } = state;

    const show_playbook = () => {
      // alert("TBD");
    };

    onMounted(() => {
      state.init();
    });
    return {
      is_loading,
      table_config,
      items,
      load_more_items,
      has_no_results,
      DynamicsTableRow,
      tabs,
      selected_tab,
      set_selected_tab,
      show_playbook,
    };
  },
});
